export default {
  BusinessStockEntryResult: {
    header: {
      queryCode: '单号',
      queryCodeText: '入库通知单号/客户订单号/内部单号/前置单号',
      status: '入库状态',
      receivingLogicWarehouseCode: '入库逻辑仓',
      receivingLogicWarehouseCodeText: '请输入逻辑仓编码',
    },

    table: {
      code: '入库结果单号',
      warehouseWarrantCode: '入库通知单号',
      inputTypeMeaning: '入库类型',
      statusMeaning: '入库状态',
      alreadyQty: '已入库数量',
      receivingLogicWarehouseCode: '入库逻辑仓编码',
      receivingLogicWarehouseName: '入库逻辑仓名称',
      storeName: '销售店铺',
      channelTypeCodeMeaning: '销售渠道',
    }
  },
  BusinessStockEntryResultView: {
    title: '基本信息',
    code: '入库结果单号',
    receivingLogicWarehouseCode: '入库逻辑仓编码',
    receivingLogicWarehouseName: '入库逻辑仓名称',
    inputTypeMeaning: '入库类型',
    statusMeaning: '入库状态',
    returnsName: '退货人',
    returnsMobile: '退货人手机号',
    cptAddress: '退货人地址',
    associated: '关联单据',
    warehouseWarrantCode: '入库通知单号',
    orderCode: '内部订单号',
    platformOrderCode: '客户订单号',
    productInformation: '商品信息',
    alreadyTotalQty: '已入库数量',
    noDataText: '暂无',

    table: {
      // spuCode: '商品编码',
      skuName: 'SKU名称',
      skuCode: 'SKU编码',
      alreadyInputQty: '已入库数量',
      // spuName: '商品名称',
    }
  }
};
